/**
 * Nouvelle version prete : proposee par « Recharger », jamais imposee.
 * `blocked` est vrai pendant une vente (PR 1.5) : le bouton n'apparait
 * qu'entre deux ventes.
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { palette } from './theme';

export default function UpdatePrompt({ ready, blocked, onReload }) {
    if (!ready || blocked) return null;
    return (
        <Box
            role="status"
            data-testid="mise-a-jour"
            sx={{
                display: 'flex', alignItems: 'center', gap: 2, px: 2, py: 1,
                bgcolor: palette.infoTint, color: palette.infoOnTint,
            }}
        >
            <SystemUpdateAltIcon aria-hidden="true" />
            <Typography sx={{ fontSize: 18, fontWeight: 600, flex: 1 }}>
                Une nouvelle version de la caisse est prête.
            </Typography>
            <Button variant="contained" onClick={onReload}>Recharger</Button>
        </Box>
    );
}
